import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {SystemSettingsGetSchema} from '../../../../api/DBSchema/SystemSettings';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import RowLayout from '../../../../components/Layouts/RowLayout';
import SMCButton from '../../../../components/Simple/SMCButton';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import TemplateEditorModal from '../../../PopupPages/TemplateEditors/TemplateEditorModal';

const pageSchema = SystemSettingsGetSchema.pages.notifications;
const pageId = pageSchema.pageId;

function SystemSettingsNotificationsGeneral({
    systemSettingsObject,
    setSystemSettingsData
}) {
    const { t } = useTranslation();

    const pageData = systemSettingsObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setSystemSettingsData([pageId, paramName], value);
    }, [setSystemSettingsData]);

    const systemMonitor           = pageData[pageSchema.systemMonitor];
    const isReportServers         = pageData[pageSchema.isReportServers];
    const isReportLicenseExceeded = pageData[pageSchema.isReportLicenseExceeded];

    const [isSystemMoitorCustomizeOpen, setIsSystemMoitorCustomizeOpen] = useState(false);
    const onSystemMoniterCustomizeSuccess = useCallback((newValue) => {
        setPageValue(pageSchema.systemMonitor, newValue);
        setIsSystemMoitorCustomizeOpen(false);
    }, [setPageValue]);

    return (
        <EditorLayout>
            {/* System monitor */}
            <RowLayout>
                <SMCLabel useContextWidth>{t('SMP.SETTINGS.NOTIFICATIONS.SYSTEM_MONITOR')}</SMCLabel>
                <SMCButton onClick={() => setIsSystemMoitorCustomizeOpen(true)}><RowLayout spacing="4px"><SMCIcon icon="rightArrow" />{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.CUSTOMIZE')}</RowLayout></SMCButton>
            </RowLayout>
            {/* Notify system admin of server and system failures */}
            <SMCCheckbox
                checked={isReportServers}
                onChange={e => setPageValue(pageSchema.isReportServers, e.target.checked)}
                label={t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.LINE1')}
            />
            {/* Notify system admin of SMP license exeeded */}
            <SMCCheckbox
                checked={isReportLicenseExceeded}
                onChange={e => setPageValue(pageSchema.isReportLicenseExceeded, e.target.checked)}
                label={t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.LINE2')}
            />
            {/* Popup pages */}
            <TemplateEditorModal
                isOpen={isSystemMoitorCustomizeOpen}
                onRequestClose={() => setIsSystemMoitorCustomizeOpen(false)}
                defaultObject={systemMonitor}
                onSuccess={onSystemMoniterCustomizeSuccess}
                templateName="systemMonitorErrors"
                isGlobal={true}
            />
        </EditorLayout>
    )
}

export default SystemSettingsNotificationsGeneral;